module.exports = __webpack_public_path__ + "static/media/piste.bb247d01.jpg";